var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"pt-0 mt-n2",attrs:{"label":_vm.field.template.name},model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }